import React, { useMemo } from "react";
import { Stack } from "@mui/material";
import ConfigHeader from "../ConfigHeader/config-header";
import ConfigTranscodeFormFields from "./ConfigTranscodeForm/config-transcode-generic-form";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import { ConfigBaseProps } from "../../../Pages/Basket/basket";
import { DbStorageInfos } from "../../../Core/Api/Types/db-storage-infos";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { FormExists, GetFormIsValid } from "../../../Redux/Reducers/redux-slice-form-validation";
import { MailingListDto } from "../../../Core/Api/Types/get-mailing-list-response";
import { UpdateItemStatusOnBasket } from "../../../Redux/Reducers/redux-slice-basket";
import { BasketItemStatus } from "../../../Core/Api/Types/basket-item-status";
import ConfigSaveButton from "../ConfigSaveButton/config-save-button";
import { GetOrderProductReadableType } from "../../../Utils/helpers";

interface ConfigTranscodeProps extends ConfigBaseProps {
  storages: DbStorageInfos[];
  maillists: MailingListDto[];
}

const ConfigTranscode: React.FC<ConfigTranscodeProps> = (props) => {
  const { handleSubmit, handleCancel, handleChangeProduct, item, storages, maillists, ...otherProps } = props;
  const formId = `form-transcode-${item.id}`;
  const formValid = useAppSelector(GetFormIsValid(formId));
  const formExists = useAppSelector(FormExists(formId));
  const dispatch = useAppDispatch();

  const formValidTrigger = useMemo(() => {
    // In case of invalid, update item status
    if (!formValid && formExists && item.status !== BasketItemStatus.OptionsDone)
      dispatch(UpdateItemStatusOnBasket({ itemId: item.id, status: BasketItemStatus.New }));

    return formValid;
  }, [formValid]);

  return (
    <Stack width={"100%"} {...otherProps} display={formExists ? "" : "none"}>
      <ConfigHeader
        configType={item.selectedProduct?.type ? item.selectedProduct?.type : OrderProductType.TranscodeGeneric}
        title={GetOrderProductReadableType(
          item.selectedProduct?.type ? item.selectedProduct?.type : OrderProductType.TranscodeGeneric
        )}
        handleCancel={handleCancel}
        handleChangeProduct={handleChangeProduct}
        itemId={item.id}
      />
      <ConfigTranscodeFormFields item={item} formid={formId} storages={storages} maillists={maillists} />
      <ConfigSaveButton item={item} onSubmit={handleSubmit} disabled={!formValidTrigger} />
    </Stack>
  );
};

export default ConfigTranscode;
